import styled from "styled-components";

export const SigninContainer = styled.div`
    height: 100vh;
    background: #000;
    align-content: center;
    justify-content: center;
    display: flex;
    position: relative;

`

export const SigninWrapper = styled.div`
    background: linear-gradient(135deg, #0a0014 0%, #1a0533 30%, #4a1c6b 70%, #8b2fc9 100%);
    min-height: 600px;
    width: 500px;
    max-width: 90%;
    margin: auto;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(200, 64, 233, 0.3);

`

export const SigninP = styled.p`
    font-weight: 600;
    margin-bottom: 5px;
    color: #fff;

`

export const SigninInput = styled.input`
    width: 100%;
    padding: 10px 10px;
    border-radius: 10px;
    border: 2px solid rgba(176, 95, 253, 0.3);
    margin-bottom: 30px;
    background: rgba(255, 255, 255, 0.1);
    color: #fff;

    &::placeholder {
        color: rgba(255, 255, 255, 0.5);
    }

    &:focus {
        outline: none;
        border-color: #B05FFD;
        background: rgba(255, 255, 255, 0.15);
    }

`